import * as React from "react";
import { useAuthDataContext } from '../components/AuthDataProvider';

export const Home = () => {
  const { user } = useAuthDataContext();
  return (
    <h1>
      Hello world {user?.user_details?.first}
    </h1>
  )
}
